import { ArrowUpRight, LogIn } from "lucide-react";
import { Reveal, WHATSAPP_URL, APP_URL, WhatsAppIcon } from "./shared";
import { LeadDialog } from "./LeadDialog";
import { DashboardMockup } from "./DashboardMockup";

export const FinalCTA = () => (
  <section id="contato" data-testid="final-cta-section" className="relative overflow-hidden py-24 sm:py-32">
    <div className="pointer-events-none absolute inset-0">
      <div className="absolute left-1/2 top-1/2 h-[520px] w-[900px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-tria-vivid/15 blur-[150px]" />
      <div className="hero-grid absolute inset-0 opacity-60" />
    </div>

    <div className="relative mx-auto max-w-5xl px-5 sm:px-8">
      <Reveal>
        <div className="relative rounded-[28px] border border-white/[0.09] bg-gradient-to-b from-tria-card/80 to-tria-navy/90 p-8 backdrop-blur-xl sm:p-14">
          <div className="pointer-events-none absolute inset-x-16 top-0 h-px bg-gradient-to-r from-transparent via-tria-sky/60 to-transparent" />

          <div className="flex flex-col items-center text-center">
            <span className="font-mono text-[10.5px] font-semibold uppercase tracking-[0.28em] text-tria-sky">
              Comece agora
            </span>
            <h2 className="mt-5 max-w-2xl font-display text-3xl font-semibold leading-[1.1] tracking-[-0.02em] text-white sm:text-4xl lg:text-5xl" data-testid="final-cta-title">
              Leve a inteligência financeira da TRIA para o seu negócio
            </h2>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-tria-mist sm:text-lg">
              Conheça a plataforma, entenda o método e veja como transformar compras, vendas e
              despesas em resultado.
            </p>

            <div className="mt-9 flex flex-col items-center gap-3.5 sm:flex-row">
              <a
                data-testid="final-cta-demo"
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="glow-blue inline-flex items-center gap-2.5 rounded-full bg-tria-vivid px-8 py-4 text-[15px] font-bold text-white transition-all duration-300 hover:scale-[1.03] hover:bg-tria-blue"
              >
                <WhatsAppIcon className="h-5 w-5" />
                Agendar demonstração
              </a>
              <a
                data-testid="final-cta-signup"
                href={APP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center gap-2 rounded-full border border-white/15 px-8 py-4 text-[15px] font-semibold text-white transition-all duration-300 hover:border-tria-sky/50 hover:bg-white/5"
              >
                Criar conta
                <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
              <a
                data-testid="final-cta-login"
                href={APP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-4 py-4 text-[15px] font-semibold text-tria-mist transition-colors hover:text-white"
              >
                <LogIn className="h-4 w-4" />
                Entrar
              </a>
            </div>

            <div className="mt-5">
              <LeadDialog
                trigger={
                  <button data-testid="final-cta-lead-btn" className="text-[13.5px] font-semibold text-tria-sky underline decoration-tria-sky/40 underline-offset-4 transition-colors hover:text-white">
                    Prefere deixar seus contatos? A equipe retorna para você
                  </button>
                }
              />
            </div>
          </div>

          <div className="pointer-events-none mt-12 select-none opacity-90 [mask-image:linear-gradient(to_bottom,black_40%,transparent_95%)]">
            <DashboardMockup compact />
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
